import { render, staticRenderFns } from "./dropzone.vue.html?vue&type=template&id=3b46635a"
import script from "./dropzone.controller.ts?vue&type=script&lang=js&external"
export * from "./dropzone.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports